import { Spinner } from '@fluentui/react/lib/Spinner';

import { spinner } from './MailListLoading.scss';

const MailListLoading = (): JSX.Element => <Spinner className={spinner} />;

export default MailListLoading;
